import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function Urgency() {
  return <section className="bg-gradient-to-br from-navy to-[#0d2e1a] py-6 sm:py-12 px-5 text-center" data-id="element-281">
      <div className="max-w-2xl mx-auto" data-id="element-282">
        <h2 className="font-display text-lg sm:text-3xl lg:text-4xl text-white mb-1 sm:mb-2 leading-tight" data-id="element-283">
          Oferta por tiempo limitado
        </h2>
        <p className="text-white/70 text-[11px] sm:text-base mb-4 sm:mb-6" data-id="element-284">
          Cuando se acaben los cupos el precio sube +$8.000 y NO vuelve a bajar.
        </p>

        <div className="max-w-md mx-auto mb-3 sm:mb-4" data-id="element-285">
          <CountdownTimer variant="dark" data-id="element-286" />
        </div>

        <div className="max-w-[240px] sm:max-w-sm mx-auto mb-1.5 sm:mb-2" data-id="element-287">
          <div className="bg-white/10 rounded-full h-1.5 sm:h-2 overflow-hidden" data-id="element-288">
            <div className="h-full w-[2%] bg-gradient-to-r from-gold to-gold-light rounded-full" data-id="element-289" />
          </div>
        </div>
        <p className="text-[10px] sm:text-sm text-white/60" data-id="element-290">
          2% de cupos tomados al precio actual
        </p>
      </div>
    </section>;
}